const intFormatter = new Intl.NumberFormat('ru', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }),
    floatFormatter = new Intl.NumberFormat('ru', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

export default {
    methods: {
        prettyInt(val) {
            return isNaN(val) ? val : intFormatter.format(val);
        },
        prettyBool(val) {
            return val ? 'Да' : 'Нет';
        },
        prettyFloat(val) {
            return isNaN(val) ? val : floatFormatter.format(val);
        },
    },
}
